import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
         
      },
      theme: {
        themes: {
          light: {
            primary: "#7f182f",
            info: "#326d99",
            warning: "#1c1c1c",
            anchor: '#8c9eff',
          },
        },
      },
  });
